import { types, getEnv, flow } from 'mobx-state-tree';

import { MobxEnvironment } from '../mobx-environment';
import { RequestStatusModel, RequestStatus } from '../../libs/helpers';
import {
  CreateFacCCRequest,
  CreateFacCCResult,
  CreateFacilityRequest,
  CreateFacilityResult,
  CreateOrganizationRequest,
  CreateOrganizationResult,
  UpdateFacEcofitRequest,
  UpdateFacEcofitResult,
  UpdateOrgContactRequest,
  UpdateFacContactRequest,
  UpdateOrgContactResult,
  UpdateFacContactResult,
  addDigitalProductsResult,
  DigitalProductsList,
} from '../../models';

export const AuotmationStoreModel = types
  .model({
    status: RequestStatusModel,
  })
  .views(self => ({
    get environment() {
      return getEnv(self) as MobxEnvironment;
    },
  }))
  .actions(self => ({
    setStatus(value: RequestStatus) {
      self.status = value;
    },
  }))
  .actions(self => ({
    createOrg: flow(function*(payload: CreateOrganizationRequest) {
      try {
        self.setStatus(RequestStatus.PENDING);
        const response: CreateOrganizationResult = yield self.environment.automationApi.createOrg(
          payload,
        );
        if (response.kind === 'ok') {
          self.setStatus(RequestStatus.DONE);
          return response.data;
        } else {
          throw new Error(response.kind);
        }
      } catch (error) {
        throw new Error(error.message || error);
      }
    }),
    updateOrgContact: flow(function*(orgId: number, payload: UpdateOrgContactRequest) {
      try {
        self.setStatus(RequestStatus.PENDING);
        const response: UpdateOrgContactResult = yield self.environment.automationApi.updateOrgContact(
          orgId,
          payload,
        );
        if (response.kind === 'ok') {
          self.setStatus(RequestStatus.DONE);
          return {};
        } else {
          throw new Error(response.kind);
        }
      } catch (error) {
        throw new Error(error.message || error);
      }
    }),
    updateFacContact: flow(function*(facId: number, payload: UpdateFacContactRequest) {
      try {
        self.setStatus(RequestStatus.PENDING);
        const response: UpdateFacContactResult = yield self.environment.automationApi.updateFacContact(
          facId,
          payload,
        );
        if (response.kind === 'ok') {
          self.setStatus(RequestStatus.DONE);
          return {};
        } else {
          throw new Error(response.kind);
        }
      } catch (error) {
        throw new Error(error.message || error);
      }
    }),
    createFac: flow(function*(payload: CreateFacilityRequest) {
      try {
        self.setStatus(RequestStatus.PENDING);
        const response: CreateFacilityResult = yield self.environment.automationApi.createFac(
          payload,
        );
        if (response.kind === 'ok') {
          self.setStatus(RequestStatus.DONE);
          return response.data;
        } else {
          throw new Error(response.kind);
        }
      } catch (error) {
        throw new Error(error.message || error);
      }
    }),
    updateFacEcofit: flow(function*(facId: number, payload: UpdateFacEcofitRequest) {
      try {
        self.setStatus(RequestStatus.PENDING);
        const response: UpdateFacEcofitResult = yield self.environment.automationApi.updateFacEcofit(
          facId,
          payload,
        );
        if (response.kind === 'ok') {
          self.setStatus(RequestStatus.DONE);
          return {};
        } else {
          throw new Error(response.kind);
        }
      } catch (error) {
        throw new Error(error.message || error);
      }
    }),
    createFacCC: flow(function*(payload: CreateFacCCRequest) {
      try {
        self.setStatus(RequestStatus.PENDING);
        const response: CreateFacCCResult = yield self.environment.automationApi.createFacCC(
          payload,
        );
        if (response.kind === 'ok') {
          self.setStatus(RequestStatus.DONE);
          return {};
        } else {
          throw new Error(response.kind);
        }
      } catch (error) {
        throw new Error(error.message || error);
      }
    }),
    addDigitalProducts: flow(function*(facId: number, payload: DigitalProductsList) {
      try {
        self.setStatus(RequestStatus.PENDING);
        const response: addDigitalProductsResult = yield self.environment.automationApi.addDigitalProducts(
          facId,
          payload,
        );
        if (response.kind === 'ok') {
          self.setStatus(RequestStatus.DONE);
          return {};
        } else {
          throw new Error(response.kind);
        }
      } catch (error) {
        throw new Error(error.message || error);
      }
    }),
  }));

type AutomationStoreType = typeof AuotmationStoreModel.Type;
export interface AutomationStore extends AutomationStoreType {}
type AutomationStoreSnapshotType = typeof AuotmationStoreModel.SnapshotType;
export interface AutomationStoreSnapshot extends AutomationStoreSnapshotType {}
